<template>
  <div class="studyplan__groupings">
    <template v-if="subscribedSubscribableGroupings.length > 0">
      <template v-for="subscribableGrouping in subscribedSubscribableGroupings">
        <SubscribableGrouping
          :key="subscribableGrouping.id"
          class="studyplan__groupings__item"
          :courses="filterCourses(subscribableGrouping)"
          :subscribable-grouping="subscribableGrouping"
          :my-subscriptions="mySubscriptions"
          :subscribables="subscribables"
          :open-all-courses="openAllCourses"
          :all-courses="courses"
        >
          <template
            slot="unsubscription"
            slot-scope="props"
          >
            <slot
              name="unsubscription"
              :unsubscriptionCourseName="props.unsubscriptionCourseName"
              :unsubscriptionSubscribableId="props.unsubscriptionSubscribableId"
            />
          </template>
        </SubscribableGrouping>
      </template>
    </template>
    <template v-else>
      <p>{{ trans('studyplan.no_studyplan_found') }}</p>
    </template>
  </div>
</template>

<script>
import SubscribableGrouping from '@/shared/studyplan/SubscribableGrouping'
import { stringSorter } from '@/helpers'

export default {
  name: 'StudyPlan',
  components: { SubscribableGrouping },
  props: {
    subscribableGroupings: {
      required: true,
    },
    courses: {
      required: true,
    },
    subscribables: {
      required: true,
    },
    mySubscriptions: {
      required: true,
    },
    allCourses: {
      required: true,
    },
    openAllCourses: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Filter and sort subscribable
    allSubscribedCourses () {
      return this.subscribedSubscribableGroupings.flatMap(grouping => this.filterCourses(grouping))
    },
    subscribedSubscribableGroupings () {
      return Object.values(this.subscribableGroupings).map((grouping) => {
        // We filter to get the subscribed subscribables
        let subscribables = grouping.subscribables.filter((id) => {
          return this.subscribables[id].mySubscription != null && this.mySubscriptions[this.subscribables[id].mySubscription].subscribed == 1
        })

        return { ...grouping, subscribables }
      }).sort(stringSorter('name'))
    },
  },
  methods: {
    filterCourses (subscribableGrouping) {
      return subscribableGrouping.subscribables.map(id => this.courses[this.subscribables[id].course]).sort(stringSorter('name'))
    },
  },
}
</script>

<style scoped lang="scss">

  .studyplan {
    &__groupings {
      display: flex;
      overflow: auto;

      &__item {
        min-width: 208px;
        border: 1px solid #eeeeee;
        height: inherit;
        margin-right:10px;

      }
    }

  }

  @media print {
    .studyplan {
      &__groupings {
        max-width: 100%;
        display:block !important;
      }
    }
  }

</style>
